{
	"locale": "pl",
	"services": [
		{
			"id": "liion",
			"slug": "recykling-baterii-litowo-jonowych",
			"name": "Recykling baterii litowo-jonowych",
			"short": "Kontrolowane rozładowanie, przetwarzanie i odzysk litu, kobaltu, niklu.",
			"desc": "Bezpieczne przyjęcie, rozładowanie i przetwarzanie ogniw oraz pakietów litowo-jonowych — od elektronarzędzi po pakiety trakcyjne i magazyny energii.",
			"stat": "96%",
			"statLabel": "poziom odzysku surowców w strumieniu bateryjnym",
			"spec": [
				"Kontrolowane zniszczenie w bezpiecznych warunkach",
				"Rozładowanie na sucho i na mokro",
				"Kategoryzacja i sortowanie według chemii ogniw (NMC, LFP, pozostałe)",
				"Rozdział na frakcje materiałowe",
				"Kwalifikacja ogniw do ponownego użycia",
				"Dokumentacja odzysku i zaświadczenia o recyklingu"
			],
			"groups": [
				"Baterie z urządzeń przenośnych",
				"Pakiety z elektronarzędzi",
				"Pakiety trakcyjne z wózków widłowych",
				"Baterie z hulajnóg i rowerów elektrycznych",
				"Pakiety z pojazdów EV i hybryd",
				"Baterie z UPS i magazynów energii",
				"Odpady poprodukcyjne i braki jakościowe",
				"Baterie uszkodzone i krytyczne",
				"Sortowanie MIX"
			]
		},
		{
			"id": "pb",
			"slug": "recykling-akumulatorow-olowiowych",
			"name": "Recykling akumulatorów ołowiowych",
			"short": "Akumulatory rozruchowe, trakcyjne i stacjonarne.",
			"desc": "Przyjęcie i przetwarzanie akumulatorów kwasowo-ołowiowych z rynku motoryzacyjnego i przemysłowego, wraz z obsługą dokumentacyjną.",
			"stat": "100%",
			"statLabel": "strumienia objętego ewidencją i dokumentacją",
			"spec": [
				"Przetwarzanie i regeneracja akumulatorów ołowiowych",
				"Bezpieczny odbiór i transport specjalistyczny",
				"Ewidencja masy i dokumentacja przekazania",
				"Rozliczenia i konkurencyjne formy płatności"
			],
			"groups": [
				"Akumulatory samochodowe (rozruchowe)",
				"Akumulatory trakcyjne",
				"Akumulatory stacjonarne",
				"Akumulatory przemysłowe"
			]
		},
		{
			"id": "sort",
			"slug": "sortowanie-tekstyliow",
			"name": "Sortowanie tekstyliów",
			"short": "Sort zero, sortowanie jakościowe i produktowe.",
			"desc": "Przyjęcie, ważenie i sortowanie strumienia tekstyliów na frakcje handlowe zgodnie z wymaganiami rynków docelowych.",
			"stat": "A–D",
			"statLabel": "frakcje jakościowe plus czyściwo i odpad",
			"spec": [
				"Przyjęcie, ważenie i ewidencja strumienia",
				"Sort zero — oddzielenie frakcji podstawowych",
				"Sortowanie jakościowe i produktowe",
				"Przygotowanie towaru do hurtu, eksportu lub czyściwa",
				"Raportowanie mas i uzysków"
			],
			"groups": [
				"Odzież damska, męska i dziecięca",
				"Obuwie i galanteria",
				"Tekstylia domowe",
				"Zabawki i dodatki",
				"Frakcje A, B, C, D",
				"Czyściwo",
				"Odpad"
			]
		},
		{
			"id": "hurt",
			"slug": "frakcje-handlowe-i-hurt-tekstyliow",
			"name": "Frakcje handlowe i hurt w Polsce",
			"short": "Partie handlowe dla hurtowni i sieci second hand.",
			"desc": "Przygotowanie i sprzedaż partii handlowych dopasowanych do kanału odbiorcy — z cennikami, miksami i stałą dostępnością.",
			"stat": "PL",
			"statLabel": "ogólnopolska sieć odbiorców hurtowych",
			"spec": [
				"Budowanie cenników, paczek i miksów",
				"Dopasowanie jakości towaru do kanału sprzedaży",
				"Koordynacja dostępności z sortownią i magazynem",
				"Obsługa zapytań i warunków sprzedaży"
			],
			"groups": [
				"Hurtownie odzieży używanej",
				"Sklepy second hand",
				"Frakcja B i outlet",
				"Mix sezonowy",
				"Obuwie i akcesoria",
				"Frakcje techniczne"
			]
		},
		{
			"id": "eksport",
			"slug": "eksport-kontenerowy-tekstyliow",
			"name": "Eksport kontenerowy tekstyliów",
			"short": "Miksy kontenerowe, paletowe i belowane na rynki zewnętrzne.",
			"desc": "Przygotowanie frakcji eksportowych i pełna koordynacja załadunków, dokumentów oraz płatności.",
			"stat": "3 rynki",
			"statLabel": "Afryka, Bliski Wschód, Ameryka Łacińska",
			"spec": [
				"Przygotowanie frakcji eksportowych C i D",
				"Budowanie miksów kontenerowych i belowanych",
				"Koordynacja jakości, ilości i dokumentów",
				"Współpraca z armatorami i spedytorami",
				"Odprawy eksportowe"
			],
			"groups": [
				"Odzież mix",
				"Obuwie",
				"Akcesoria",
				"Frakcje belowane",
				"Kolekcje sezonowe i zimowe"
			]
		},
		{
			"id": "czysciwo",
			"slug": "czysciwo-i-frakcje-techniczne",
			"name": "Czyściwo i frakcje techniczne",
			"short": "Tekstylia przekierowane do zastosowań przemysłowych.",
			"desc": "Wydzielenie i przygotowanie tekstyliów nadających się na czyściwo przemysłowe — zamiast utylizacji.",
			"stat": "0 odpadu",
			"statLabel": "cel: minimalizacja frakcji odpadowej",
			"spec": [
				"Wydzielenie tekstyliów do czyściwa",
				"Podział wg składu, koloru i użyteczności",
				"Belowanie, cięcie i pakowanie",
				"Sprzedaż zakładom i serwisom"
			],
			"groups": [
				"Bawełna jasna",
				"Bawełna kolorowa",
				"Dzianiny i koszulki",
				"Pościel",
				"Frakcje przemysłowe"
			]
		},
		{
			"id": "pszok",
			"slug": "tekstylia-z-pszok-i-zbiorek",
			"name": "Strumienie z PSZOK, gmin i zbiórek",
			"short": "Model przyjęcia i sortowania tekstyliów komunalnych.",
			"desc": "Wsparcie operacyjne samorządów w realizacji obowiązku selektywnej zbiórki tekstyliów wraz z rekomendacją modelu zagospodarowania.",
			"stat": "2025",
			"statLabel": "obowiązek selektywnej zbiórki tekstyliów",
			"spec": [
				"Wsparcie modelu przyjęcia i sortowania z PSZOK",
				"Ocena jakości strumienia i rekomendacja modelu",
				"Przygotowanie strumienia do dalszego zagospodarowania",
				"Raportowanie mas i kierunków"
			],
			"groups": [
				"PSZOK i gminy",
				"Zbiórki door-to-door",
				"Akcje lokalne i szkolne",
				"Zakłady pracy",
				"Kanały kurierskie"
			]
		},
		{
			"id": "premium",
			"slug": "selekcja-premium-do-re-commerce",
			"name": "Selekcja premium do re-commerce",
			"short": "Wydzielenie towaru o podwyższonej wartości jednostkowej.",
			"desc": "Identyfikacja i przygotowanie odzieży markowej oraz akcesoriów do sprzedaży jednostkowej w kanałach internetowych.",
			"stat": "1:1",
			"statLabel": "klasyfikacja jednostkowa: marka, stan, sezon",
			"spec": [
				"Wydzielenie rzeczy o podwyższonej wartości",
				"Ocena przydatności do sprzedaży internetowej",
				"Klasyfikacja: marka, stan, sezon, kategoria",
				"Przekazanie do kanału e-commerce"
			],
			"groups": [
				"Odzież markowa i premium",
				"Buty i torebki",
				"Akcesoria",
				"Kolekcje sezonowe",
				"Towar nowy i outletowy"
			]
		},
		{
			"id": "zsee",
			"slug": "recykling-zsee-agd",
			"name": "Recykling ZSEE — duże i małe AGD",
			"short": "Pełen strumień zużytego sprzętu elektrycznego i elektronicznego.",
			"desc": "Przetwarzanie zużytego sprzętu elektrycznego i elektronicznego zgodnie z ustawą o ZSEE — od sprzętu chłodniczego po drobne AGD i sprzęt biurowy.",
			"stat": "6 grup",
			"statLabel": "kategorii sprzętu objętych przetwarzaniem",
			"spec": [
				"Kontrolowane zniszczenie i przetwarzanie",
				"Demontaż i separacja frakcji materiałowych",
				"Wydzielenie baterii i komponentów niebezpiecznych",
				"Obsługa sprzętu kompletnego i niekompletnego",
				"Ewidencja BDO i karty przekazania odpadów"
			],
			"groups": [
				"Urządzenia chłodnicze",
				"Pralki, suszarki i zmywarki",
				"Sprzęt kuchenny i piekarniki",
				"Klimatyzacja i wentylacja",
				"Drobne AGD",
				"Sprzęt biurowy",
				"Sprzęt telekomunikacyjny",
				"Źródła światła"
			]
		},
		{
			"id": "chlod",
			"slug": "recykling-chlodnictwa-i-pomp-ciepla",
			"name": "Recykling chłodnictwa i pomp ciepła",
			"short": "Lodówki, witryny, zamrażarki, klimatyzacja, pompy ciepła.",
			"desc": "Specjalistyczne przetwarzanie sprzętu chłodniczego wraz z bezpiecznym odzyskiem czynników chłodniczych i frakcji materiałowych.",
			"stat": "Z3",
			"statLabel": "zakłady przetwarzania chłodnictwa w grupie",
			"spec": [
				"Kontrolowane zniszczenie i przetwarzanie",
				"Odzysk czynników chłodniczych",
				"Separacja tworzyw, metali i pianek",
				"Obsługa sprzętu handlowego i przemysłowego"
			],
			"groups": [
				"Lodówki domowe",
				"Witryny i lady chłodnicze",
				"Szafy chłodnicze",
				"Zamrażarki",
				"Klimatyzacje",
				"Pompy ciepła",
				"Bojlery i wymienniki ciepła",
				"Maszyny vendingowe",
				"Płyty warstwowe"
			]
		},
		{
			"id": "pcb",
			"slug": "recykling-elektroniki-i-pcb",
			"name": "Recykling elektroniki i PCB",
			"short": "Płytki drukowane, laminaty, sprzęt IT i serwerowy.",
			"desc": "Odzysk metali szlachetnych i frakcji technicznych z płytek obwodów drukowanych oraz kompletnych urządzeń IT.",
			"stat": "24 h",
			"statLabel": "reakcja na zgłoszenie odbioru",
			"spec": [
				"Kontrolowane zniszczenie i przetwarzanie",
				"Specjalistyczny transport",
				"Kategoryzacja laminatów i frakcji",
				"Dedykowany opiekun i szybkie rozliczenie"
			],
			"groups": [
				"Płytki obwodów drukowanych",
				"Laminaty miedziane i złote",
				"Twarde dyski i napędy",
				"Zasilacze",
				"Laptopy i komputery PC",
				"Serwery",
				"Routery i switche",
				"Tablety i telefony"
			]
		},
		{
			"id": "pv",
			"slug": "recykling-paneli-pv-i-falownikow",
			"name": "Recykling paneli PV i falowników",
			"short": "Panele fotowoltaiczne, konwertery, osprzęt.",
			"desc": "Zagospodarowanie wyeksploatowanych i uszkodzonych instalacji fotowoltaicznych wraz z osprzętem towarzyszącym.",
			"stat": "OZE",
			"statLabel": "obsługa obowiązków środowiskowych dla OZE",
			"spec": [
				"Kontrolowane zniszczenie i przetwarzanie",
				"Demontaż i odbiór instalacji",
				"Separacja szkła, ram i komponentów",
				"Dokumentacja dla wprowadzających"
			],
			"groups": [
				"Panele fotowoltaiczne",
				"Panele hybrydowe i kolektory",
				"Falowniki i konwertery",
				"Kable, stojaki i aparatura towarzysząca"
			]
		},
		{
			"id": "toner",
			"slug": "recykling-tonerow-i-kartridzy",
			"name": "Recykling tonerów i kartridży",
			"short": "Kasety, tuby, cartridge, proszek tonerowy.",
			"desc": "Przetwarzanie odpadów tonerowych z sektora biurowego i przemysłowego — bezpiecznie i z pełną dokumentacją.",
			"stat": "B2B",
			"statLabel": "obsługa sieci biur i punktów serwisowych",
			"spec": [
				"Kontrolowane zniszczenie i przetwarzanie",
				"Odbiór z wielu lokalizacji klienta",
				"Ewidencja i sprawozdawczość",
				"Raportowanie mas dla klienta"
			],
			"groups": ["Kasety tonerowe", "Tuby tonerowe", "Cartridge", "Proszek tonerowy"]
		},
		{
			"id": "inne",
			"slug": "opony-meble-i-frakcje-pozostale",
			"name": "Opony, meble i frakcje pozostałe",
			"short": "Strumienie nietypowe i mieszane.",
			"desc": "Zagospodarowanie odpadów spoza głównych strumieni — mebli, opon i frakcji mieszanych z zakładów produkcyjnych i handlu.",
			"stat": "MIX",
			"statLabel": "obsługa strumieni mieszanych i nietypowych",
			"spec": [
				"Przetwarzanie i regeneracja",
				"Odbiór wolumenów przemysłowych",
				"Ocena strumienia i rekomendacja kierunku zagospodarowania",
				"Rozwiązania designerskie z surowców wtórnych"
			],
			"groups": [
				"Meble korpusowe i domowe",
				"Meble biurowe",
				"Meble specjalistyczne",
				"Meble ogrodowe",
				"Opony osobowe i ciężarowe",
				"Opony maszyn rolniczych",
				"Inne odpady"
			]
		},
		{
			"id": "refurb",
			"slug": "reuse-i-refurbishment",
			"name": "REUSE i refurbishment",
			"short": "Testy, diagnostyka, regeneracja i odnowienie sprzętu.",
			"desc": "Wieloetapowa weryfikacja sprawności, naprawa i odnowienie wizualno-techniczne urządzeń z drugiego obiegu przed ponownym wprowadzeniem do obrotu.",
			"stat": "Grade A–D",
			"statLabel": "standaryzowana klasyfikacja jakościowa",
			"spec": [
				"Testowanie, diagnostyka techniczna i weryfikacja sprawności",
				"Regeneracja, czyszczenie i naprawa",
				"Odnawianie wizualno-techniczne",
				"Kompletacja akcesoriów i bezpieczne pakowanie",
				"Certyfikacja sprawności technicznej"
			],
			"groups": [
				"Duże AGD wolnostojące i do zabudowy",
				"Małe AGD kuchenne",
				"AGD do domu i pielęgnacji odzieży",
				"AGD sezonowe i mikroklimat",
				"Elektronarzędzia i sprzęt ogrodowy",
				"RTV i audio",
				"Elektronika użytkowa, IT i GSM",
				"Personal care"
			]
		},
		{
			"id": "grading",
			"slug": "grading-i-certyfikacja-sprawnosci",
			"name": "Grading i certyfikacja sprawności",
			"short": "Standaryzacja oceny stanu technicznego i wizualnego.",
			"desc": "Jednolity system klasyfikacji jakościowej pozwalający kupującemu dokładnie wiedzieć, co otrzymuje — od Grade A po części zamienne.",
			"stat": "5 klas",
			"statLabel": "poziomów jakościowych w standardzie grupy",
			"spec": [
				"Standaryzacja oceny stanu technicznego i użytkowego",
				"Klasy Grade A / B / C / D / Outlet",
				"Weryfikacja kompletności",
				"Certyfikat sprawności i karta produktu",
				"Custom grading pod specyfikację kupującego"
			],
			"groups": [
				"Sprzęt testowany (tested/working)",
				"Sprzęt nietestowany kompletny",
				"Sprzęt niekompletny / na części",
				"Towar powystawowy",
				"Zwroty konsumenckie"
			]
		},
		{
			"id": "depak",
			"slug": "depakietyzacja-i-odzysk-ogniw",
			"name": "Depakietyzacja i odzysk ogniw",
			"short": "Rozbiórka pakietów, pomiary i konfekcjonowanie ogniw.",
			"desc": "Odzysk sprawnych ogniw z pakietów bateryjnych i przygotowanie ich do drugiego życia w magazynach energii i zastosowaniach przemysłowych.",
			"stat": "4 typy",
			"statLabel": "ogniwa cylindryczne, pryzmatyczne, pouch, moduły",
			"spec": [
				"Depakietyzacja pakietów bateryjnych",
				"Pomiary parametrów ogniw",
				"Sortowanie i konfekcjonowanie",
				"Kwalifikacja do ponownego użycia",
				"Sprzedaż ogniw odbiorcom krajowym i zagranicznym"
			],
			"groups": [
				"Ogniwa cylindryczne",
				"Ogniwa pryzmatyczne",
				"Ogniwa pouch",
				"Moduły bateryjne",
				"Frakcje materiałowe"
			]
		},
		{
			"id": "data",
			"slug": "certyfikowane-czyszczenie-danych",
			"name": "Certyfikowane czyszczenie danych",
			"short": "Bezpowrotne usunięcie danych z nośników z raportem.",
			"desc": "Usługa dla firm odsprzedających sprzęt IT — certyfikat trwałego usunięcia danych zgodnie z RODO i ISO 27001.",
			"stat": "RODO",
			"statLabel": "zgodność z RODO i ISO 27001",
			"spec": [
				"Bezpowrotne usunięcie danych z nośników",
				"Certyfikat i raport dla każdego urządzenia",
				"Obsługa flot firmowych",
				"Możliwość fizycznego zniszczenia nośnika"
			],
			"groups": [
				"Laptopy i komputery",
				"Dyski twarde i SSD",
				"Smartfony i tablety",
				"Serwery i macierze",
				"Nośniki przenośne"
			]
		},
		{
			"id": "omni",
			"slug": "sprzedaz-wielokanalowa-d2c-i-b2b",
			"name": "Sprzedaż wielokanałowa D2C i B2B",
			"short": "Sklep własny, marketplace, hurt paletowy i stokowy.",
			"desc": "Komercjalizacja towaru REUSE w kanałach detalicznych i hurtowych wraz z obsługą zwrotów i reklamacji.",
			"stat": "4 kanały",
			"statLabel": "sklep własny, marketplace, hurt, eksport",
			"spec": [
				"Sprzedaż detaliczna D2C: sklep własny i platformy marketplace",
				"Sprzedaż hurtowa B2B: palety, pakiety, stoki",
				"Zarządzanie logistyką zwrotną",
				"Obsługa reklamacji i zwrotów konsumenckich",
				"Usługi dodane: gwarancja rozszerzona, dostawa z wniesieniem"
			],
			"groups": [
				"Sprzęt REUSE i refurbished",
				"Nadwyżki magazynowe",
				"Zwroty konsumenckie",
				"Towar powystawowy",
				"Stoki boxowe",
				"Książki i media",
				"Części i komponenty"
			]
		},
		{
			"id": "asset",
			"slug": "asset-recovery-i-sprzedaz-hurtowa",
			"name": "Asset recovery i sprzedaż hurtowa",
			"short": "Wolumeny kontenerowe i paletowe na rynki PL i eksport.",
			"desc": "Odzysk wartości z nadwyżek, zwrotów i końcówek serii w modelu hurtowym — z pełną obsługą celno-eksportową.",
			"stat": "20/40 ft",
			"statLabel": "wolumeny kontenerowe i hurt paletowy",
			"spec": [
				"Kwalifikacja jakościowa i kategoryzacja surowcowo-towarowa",
				"Kompleksowa obsługa B2B na rynek PL i rynki zagraniczne",
				"Organizacja odpraw i dokumentacji celno-eksportowej",
				"Logistyka międzynarodowa i koordynacja załadunków",
				"Negocjacje handlowe"
			],
			"groups": [
				"Stoki hurtowe RTV/AGD",
				"Palety zwrotów konsumenckich",
				"Kontenery B2B",
				"Tekstylia i odzież używana",
				"Elektronarzędzia i sprzęt przemysłowy",
				"Panele PV i osprzęt",
				"Opony",
				"Książki, tonery i kartridże"
			]
		},
		{
			"id": "kaucja",
			"slug": "obsluga-wprowadzajacych-w-systemie-kaucyjnym",
			"name": "Obsługa wprowadzających w systemie kaucyjnym",
			"short": "Onboarding, umowy, modele rozliczeń i raportowanie.",
			"desc": "Kompleksowe przygotowanie producenta napojów do obowiązków systemu kaucyjnego — od analizy SKU po bieżącą obsługę i rozliczenia.",
			"stat": "2025",
			"statLabel": "system kaucyjny działa od 1 października 2025",
			"spec": [
				"Onboarding wprowadzającego do systemu",
				"Analiza wolumenów, liczby SKU i struktury sprzedaży",
				"Modele finansowe: opłata operatora, kaucja, handling fee",
				"Koordynacja między działami handlowym, prawnym i operacjami",
				"Raportowanie i Business Review"
			],
			"groups": [
				"Butelki jednorazowe PET",
				"Puszki metalowe (aluminium, stal)",
				"Butelki szklane wielokrotnego użytku",
				"SKU producentów napojów",
				"Dystrybutorzy i importerzy"
			]
		},
		{
			"id": "rop",
			"slug": "rop-baterie-tekstylia-oze",
			"name": "ROP: baterie, tekstylia, OZE",
			"short": "Obsługa rozszerzonej odpowiedzialności producenta.",
			"desc": "Realizacja obowiązków wynikających z ROP dla poszczególnych kategorii produktowych — z doborem właściwej ścieżki i systemu.",
			"stat": "3 strumienie",
			"statLabel": "baterie · tekstylia · OZE i elektronika",
			"spec": [
				"Analiza obowiązków ROP dla kategorii produktowej",
				"Dobór dedykowanego systemu obsługi",
				"Wdrożenie procesów zbiórki, odzysku i raportowania",
				"Bieżąca obsługa i optymalizacja kosztów",
				"Aktualizacja zgodności z przepisami"
			],
			"groups": [
				"Baterie i akumulatory",
				"Tekstylia",
				"Sprzęt elektryczny i elektroniczny",
				"Panele PV i OZE",
				"Opakowania"
			]
		},
		{
			"id": "bdo",
			"slug": "ewidencja-odpadow-i-bdo",
			"name": "Ewidencja odpadów i BDO",
			"short": "Nadzór nad ewidencją i sprawozdawczością zakładu.",
			"desc": "Prowadzenie i nadzór nad ewidencją odpadów w systemie BDO oraz wsparcie w sprawozdawczości okresowej.",
			"stat": "BDO",
			"statLabel": "pełna ewidencja i sprawozdawczość",
			"spec": [
				"Nadzór nad procesem gospodarki odpadowej zakładu",
				"Prowadzenie ewidencji w systemie BDO",
				"Wystawianie i potwierdzanie KPO",
				"Przygotowanie sprawozdań okresowych",
				"Identyfikacja braków danych i ryzyk"
			],
			"groups": [
				"Zakłady produkcyjne",
				"Sieci handlowe",
				"Instytucje publiczne",
				"Operatorzy logistyczni",
				"Podmioty wprowadzające"
			]
		},
		{
			"id": "dok",
			"slug": "dokumentacja-odzysku-i-zaswiadczenia",
			"name": "Dokumentacja odzysku i zaświadczenia",
			"short": "KPO, zaświadczenia o recyklingu, zestawienia mas.",
			"desc": "Komplet dokumentów potwierdzających prawidłowe przekazanie i przetworzenie odpadów — do wykorzystania we własnej sprawozdawczości.",
			"stat": "100%",
			"statLabel": "zgłoszeń z pełną dokumentacją odzysku",
			"spec": [
				"Wystawianie i potwierdzanie Kart Przekazania Odpadów",
				"Zaświadczenia o recyklingu",
				"Roczne zestawienia mas odebranych i przetworzonych",
				"Dokumentacja dla audytów i przetargów"
			],
			"groups": [
				"KPO",
				"Zaświadczenia o recyklingu",
				"Zestawienia roczne",
				"Raporty dla audytów",
				"Dokumentacja przetargowa"
			]
		},
		{
			"id": "srodowisko",
			"slug": "doradztwo-srodowiskowe-i-zezwolenia",
			"name": "Doradztwo środowiskowe i zezwolenia",
			"short": "Pozwolenia, zgodność, rachunkowość środowiskowa.",
			"desc": "Wsparcie w uzyskiwaniu zezwoleń, prowadzeniu rachunkowości środowiskowej i utrzymaniu zgodności z przepisami.",
			"stat": "Compliance",
			"statLabel": "od zezwolenia po bieżącą zgodność",
			"spec": [
				"Doradztwo w zakresie ochrony środowiska",
				"Uzyskiwanie zezwoleń na prowadzenie działalności",
				"Rachunkowość i sprawozdawczość środowiskowa",
				"Przestrzeganie przepisów prawa ochrony środowiska",
				"Audyt gospodarki odpadami u klienta"
			],
			"groups": [
				"Zakłady przetwarzania",
				"Producenci i wprowadzający",
				"Operatorzy logistyczni",
				"Samorządy",
				"MŚP w łańcuchu wartości"
			]
		},
		{
			"id": "adr",
			"slug": "odbior-i-transport-adr",
			"name": "Odbiór i transport ADR",
			"short": "Cykliczne, jednorazowe i interwencyjne odbiory baterii.",
			"desc": "Bezpieczny transport odpadów niebezpiecznych — w tym baterii litowo-jonowych uszkodzonych i krytycznych — własną, wyspecjalizowaną flotą.",
			"stat": "ADR",
			"statLabel": "własna flota i bezpieczne pojemniki ASP",
			"spec": [
				"Odbiór transportem ADR",
				"Odbiory cykliczne wg harmonogramu",
				"Odbiory jednorazowe i interwencyjne",
				"Konsolidacja tras dla klientów wielolokalizacyjnych",
				"Odbiór baterii uszkodzonych po weryfikacji stanu"
			],
			"groups": [
				"Baterie EOL",
				"Baterie uszkodzone i krytyczne",
				"Baterie samochodowe w całości",
				"Odpady poprodukcyjne",
				"Pakiety trakcyjne",
				"Strumień ZSEE"
			]
		},
		{
			"id": "pojemniki",
			"slug": "dzierzawa-pojemnikow-li-ion",
			"name": "Dzierżawa pojemników Li-ion",
			"short": "Cztery linie pojemników: OFFICE, CHARGE, TRANS-STORE, RESCUE.",
			"desc": "Dobór, dostawa i rotacja pojemników do bezpiecznego magazynowania i ładowania baterii litowo-jonowych — w modelu dzierżawy.",
			"stat": "4 linie",
			"statLabel": "OFFICE · CHARGE · TRANS-STORE · RESCUE",
			"spec": [
				"Dobór pojemnika do wolumenu i rodzaju odpadu",
				"Dzierżawa z rotacją pojemnika przy odbiorze",
				"Bezpieczne ładowanie w izolowanym pojemniku",
				"Jednolita identyfikacja i ewidencja floty",
				"Model wyłącznie dzierżawy — bez zakupu"
			],
			"groups": [
				"Pojemniki biurowe (OFFICE)",
				"Pojemniki do ładowania (CHARGE)",
				"Pojemniki stanowiskowe (TRANS-STORE)",
				"Pojemniki magazynowe",
				"Pojemniki przemysłowe i hubowe",
				"Pojemniki na baterie uszkodzone (RESCUE)"
			]
		},
		{
			"id": "siec",
			"slug": "sieci-pojemnikow-i-punkty-zbiorki",
			"name": "Sieci pojemników i punkty zbiórki",
			"short": "Ogólnopolska sieć zbiórki elektroodpadów i baterii.",
			"desc": "Projektowanie i utrzymanie sieci punktów zbiórki dla firm, sieci handlowych, samorządów i placówek oświatowych.",
			"stat": "PL",
			"statLabel": "ogólnopolska sieć czerwonych pojemników",
			"spec": [
				"Projektowanie lokalnych systemów zbiórki",
				"Instalacja i serwis pojemników",
				"Mobilne i stacjonarne punkty zbiórki",
				"Obsługa zgłoszeń i interwencji",
				"Raportowanie efektów i wskaźników"
			],
			"groups": [
				"Czerwone pojemniki na elektroodpady",
				"Pojemniki na baterie",
				"Punkty przy jednostkach OSP",
				"Punkty w centrach handlowych",
				"Zbiórki szkolne i biurowe",
				"Mobilne zbiórki miejskie"
			]
		},
		{
			"id": "zwrotna",
			"slug": "logistyka-zwrotna-i-odbiory-z-domu",
			"name": "Logistyka zwrotna i odbiory z domu",
			"short": "Odbiory B2C, B2B i wielkogabarytowe z lokalizacji klienta.",
			"desc": "Pełna organizacja odbiorów zużytego sprzętu — od zgłoszenia przez formularz po wyniesienie sprzętu i dokumentację.",
			"stat": "24/7",
			"statLabel": "zgłoszenie odbioru przez formularz internetowy",
			"spec": [
				"Przyjmowanie zleceń odbioru sprzętu",
				"Odbiór wielkogabarytowy z domu mieszkańca",
				"Usługa wyniesienia ze wskazanej lokalizacji",
				"Koordynacja terminów z logistyką i przewoźnikami",
				"Wsparcie posprzedażowe: raporty, rozliczenia, reklamacje"
			],
			"groups": [
				"Gospodarstwa domowe",
				"Firmy i przedsiębiorstwa",
				"Instytucje publiczne",
				"Jednostki samorządu terytorialnego",
				"Szkoły i placówki oświatowe",
				"Spółdzielnie i wspólnoty"
			]
		},
		{
			"id": "zwrotomat",
			"slug": "punkty-zwrotu-i-zwrotomaty",
			"name": "Punkty zwrotu i zwrotomaty",
			"short": "Automaty zwrotu opakowań kaucyjnych dla gmin i retailu.",
			"desc": "Instalacja i obsługa punktów zwrotu opakowań kaucyjnych — przy urzędach, centrach przesiadkowych i parkingach.",
			"stat": "Kaucja",
			"statLabel": "automatyczne rozliczanie kaucji z operatorem",
			"spec": [
				"Instalacja zwrotomatów na terenach gminnych i w retailu",
				"Automatyczne rozliczanie kaucji",
				"Przekazywanie danych do operatora systemu",
				"Odbiór zebranych opakowań",
				"Monitoring zapełnienia urządzeń"
			],
			"groups": [
				"Butelki PET",
				"Puszki metalowe",
				"Butelki szklane wielokrotnego użytku",
				"Punkty przy urzędach",
				"Centra przesiadkowe i Park & Ride"
			]
		},
		{
			"id": "bpo",
			"slug": "bpo-operacyjne-i-technologiczne",
			"name": "BPO operacyjne i technologiczne",
			"short": "Outsourcing operacji: BOK, logistyka, sortownie, rozliczenia.",
			"desc": "Przejęcie i prowadzenie całości operacji obiegu opakowań lub odpadów — od pierwszej mili po rozliczenia i analitykę.",
			"stat": "End-to-end",
			"statLabel": "od pierwszej mili po rozliczenia",
			"spec": [
				"Zarządzanie logistyką pierwszej i drugiej mili",
				"Pozysk i zarządzanie punktami konsolidacyjnymi",
				"Sortownie i centra liczenia",
				"Integracje z podwykonawcami i recyklerami",
				"Rozliczenia, ewidencje i analityka danych"
			],
			"groups": [
				"System kaucyjny",
				"ROP — tekstylia",
				"ROP — baterie",
				"Punkty zbiórki",
				"Skanery i zwrotomaty",
				"Worki i plomby"
			]
		},
		{
			"id": "analiza",
			"slug": "analiza-i-strategia-esg",
			"name": "Analiza i strategia ESG",
			"short": "Audyt modelu biznesowego, podwójna istotność, mapa interesariuszy.",
			"desc": "Osiem kroków od warsztatu i zebrania danych po analizę podwójnej istotności i zgodność z Taksonomią UE.",
			"stat": "8 kroków",
			"statLabel": "ustandaryzowany proces analizy ESG",
			"spec": [
				"Spotkanie warsztatowo-szkoleniowe i rekomendacje",
				"Zebranie i weryfikacja danych E, S, G",
				"Audyt modelu biznesowego z analizą luk",
				"Analiza podwójnej istotności",
				"Mapa interesariuszy i plan komunikacji",
				"Analiza zgodności z Taksonomią UE"
			],
			"groups": [
				"Duże przedsiębiorstwa",
				"MŚP w łańcuchu wartości",
				"Grupy kapitałowe",
				"Podmioty przetargowe",
				"Jednostki samorządu"
			]
		},
		{
			"id": "raport",
			"slug": "raport-esg-csrd-esrs",
			"name": "Raport ESG wg CSRD/ESRS",
			"short": "Pełny raport niefinansowy zgodny ze standardami europejskimi.",
			"desc": "Opracowanie raportu zrównoważonego rozwoju bazującego na ESRS i wytycznych branżowych, przygotowanego pod późniejszą atestację.",
			"stat": "ESRS",
			"statLabel": "pełen zakres E1–E5, S1–S4, G1",
			"spec": [
				"Pełny raport niefinansowy wg ESRS",
				"Rzetelna analiza danych i mierników",
				"Wsparcie w spełnieniu obowiązku prawnego",
				"Przygotowanie wkładu do raportów w łańcuchu wartości",
				"Budowanie wiarygodności wobec inwestorów"
			],
			"groups": [
				"ESRS 1–2 — wymogi ogólne",
				"E1 Zmiana klimatu",
				"E2 Zanieczyszczenia",
				"E3 Woda",
				"E4 Bioróżnorodność",
				"E5 GOZ",
				"S1–S4 Obszary społeczne",
				"G1 Ład korporacyjny"
			]
		},
		{
			"id": "slad",
			"slug": "slad-weglowy-zakres-1-2-3",
			"name": "Ślad węglowy — Zakres 1, 2 i 3",
			"short": "Obliczenia emisji bezpośrednich i pośrednich.",
			"desc": "Policzenie śladu węglowego organizacji w trzech zakresach wraz z rekomendacjami dekarbonizacyjnymi.",
			"stat": "Scope 1–3",
			"statLabel": "pełny zakres emisji organizacji",
			"spec": [
				"Zakres I — emisje bezpośrednie",
				"Zakres II — pośrednie emisje energetyczne",
				"Zakres III — emisje w łańcuchu wartości",
				"Polityka dekarbonizacji",
				"Przygotowanie danych do raportu"
			],
			"groups": [
				"Emisje procesowe",
				"Energia elektryczna i cieplna",
				"Zakupione surowce i usługi",
				"Transport i logistyka",
				"Użytkowanie produktów",
				"Zagospodarowanie odpadów"
			]
		},
		{
			"id": "szkolenia",
			"slug": "szkolenia-i-warsztaty-esg",
			"name": "Szkolenia i warsztaty ESG",
			"short": "Programy wprowadzające i dedykowane per obszar ESRS.",
			"desc": "Szkolenia dla kadry zarządzającej i zespołów operacyjnych — od podstaw CSRD po szczegółowe omówienie standardów.",
			"stat": "20+",
			"statLabel": "tematów szkoleniowych w katalogu",
			"spec": [
				"Szkolenia wprowadzające do ESG i CSRD",
				"Szkolenia dla podmiotów raportujących",
				"Szkolenia dedykowane per obszar ESRS",
				"Warsztaty z analizy luk i podwójnej istotności",
				"Greenwashing i ochrona sygnalistów"
			],
			"groups": [
				"Kadra zarządzająca",
				"Działy finansowe i compliance",
				"Zespoły operacyjne",
				"Działy zakupów",
				"Jednostki samorządu"
			]
		},
		{
			"id": "city",
			"slug": "esg-city-miasta-i-samorzady",
			"name": "ESG City — miasta i samorządy",
			"short": "Doradztwo, raportowanie i programy miejskie.",
			"desc": "Wdrażanie zasad zrównoważonego rozwoju w jednostkach samorządu terytorialnego wraz z programami zbiórki i edukacji.",
			"stat": "Smart City",
			"statLabel": "analityka danych i wskaźniki GOZ",
			"spec": [
				"Doradztwo i raportowanie ESG dla miast i gmin",
				"Programy zbiórki i rywalizacji miast",
				"Analiza danych o zbiórce i monitoring urządzeń",
				"Integracja z miejskimi systemami IT",
				"Raportowanie wskaźników recyklingu"
			],
			"groups": [
				"Urzędy miast i gmin",
				"Związki międzygminne",
				"PSZOK",
				"Spółki komunalne",
				"Placówki oświatowe"
			]
		},
		{
			"id": "edu",
			"slug": "edukacja-ekologiczna-i-kampanie-csr",
			"name": "Edukacja ekologiczna i kampanie CSR",
			"short": "Programy dla szkół, kampanie społeczne, zbiórki charytatywne.",
			"desc": "Projektowanie i realizacja działań angażujących pracowników, klientów i społeczności lokalne wokół realnego efektu środowiskowego.",
			"stat": "Efekt",
			"statLabel": "mierzymy zmianę zachowań, nie tylko zasięgi",
			"spec": [
				"Kampanie CSR angażujące pracowników i klientów",
				"Warsztaty, pikniki i eventy ekologiczne",
				"Programy edukacyjne dla szkół i przedszkoli",
				"Zbiórki łączące cel środowiskowy z charytatywnym",
				"Pomiar efektu behawioralnego działań"
			],
			"groups": [
				"Szkoły i przedszkola",
				"Uczelnie",
				"Centra handlowe",
				"Firmy i zakłady pracy",
				"Jednostki OSP",
				"Organizacje pozarządowe"
			]
		},
		{
			"id": "bok",
			"slug": "bok-i-infolinia-srodowiskowa",
			"name": "BOK i infolinia środowiskowa",
			"short": "Obsługa zgłoszeń telefonicznych, mailowych i internetowych.",
			"desc": "Kompleksowa obsługa klienta w kanałach B2B i B2C zgodna z ustawą o ZSEE oraz wymaganiami BDO.",
			"stat": "B2B + B2C",
			"statLabel": "jedna obsługa dla obu kanałów",
			"spec": [
				"Obsługa infolinii i zgłoszeń wielokanałowych",
				"Przyjmowanie zleceń odbiorów",
				"Wsparcie w przygotowaniu odpadów do odbioru",
				"Koordynacja terminów z logistyką",
				"Raportowanie wyników i analiza efektywności"
			],
			"groups": [
				"Zgłoszenia telefoniczne",
				"Zgłoszenia e-mail",
				"Formularz internetowy",
				"Interwencje pojemnikowe",
				"Reklamacje i rozliczenia"
			]
		}
	],
	"categories": [
		{
			"id": "bat",
			"num": "01",
			"slug": "recykling-baterii",
			"title": "Recykling baterii",
			"summary": "Bezpieczne przyjęcie, rozładowanie i przetwarzanie ogniw litowo-jonowych oraz akumulatorów ołowiowych — od elektronarzędzi po pakiety trakcyjne i magazyny energii.",
			"serviceIds": ["liion", "pb"]
		},
		{
			"id": "txt",
			"num": "02",
			"slug": "recykling-tekstyliow",
			"title": "Recykling tekstyliów",
			"summary": "Sortowanie, komercjalizacja i zagospodarowanie strumienia tekstyliów — od PSZOK i zbiórek po eksport kontenerowy i czyściwo przemysłowe.",
			"serviceIds": ["sort", "hurt", "eksport", "czysciwo", "pszok", "premium"]
		},
		{
			"id": "weee",
			"num": "03",
			"slug": "zuzyty-sprzet-elektroniczny",
			"title": "Zużyty sprzęt elektroniczny (WEEE)",
			"summary": "Przetwarzanie pełnego strumienia ZSEE zgodnie z ustawą — duże i małe AGD, chłodnictwo, elektronika, panele PV oraz frakcje pozostałe.",
			"serviceIds": ["zsee", "chlod", "pcb", "pv", "toner", "inne"]
		},
		{
			"id": "reuse",
			"num": "04",
			"slug": "reuse-i-wydluzanie-zycia-produktu",
			"title": "REUSE i wydłużanie życia produktu",
			"summary": "Wydłużanie życia produktu zamiast recyklingu: testowanie, regeneracja, standaryzowany grading, odzysk ogniw i certyfikowane czyszczenie danych.",
			"serviceIds": ["refurb", "grading", "depak", "data"]
		},
		{
			"id": "recom",
			"num": "05",
			"slug": "re-commerce",
			"title": "RE-COMMERCE",
			"summary": "Komercjalizacja towaru z drugiego obiegu: sprzedaż D2C i B2B, hurt paletowy i kontenerowy oraz asset recovery na rynkach krajowych i eksportowych.",
			"serviceIds": ["omni", "asset"]
		},
		{
			"id": "kauc",
			"num": "06",
			"slug": "system-kaucyjny-i-rop",
			"title": "System kaucyjny i ROP",
			"summary": "Obowiązki regulacyjne wprowadzających — obsługa w systemie kaucyjnym, ROP dla baterii, tekstyliów i OZE, ewidencja BDO oraz dokumentacja odzysku.",
			"serviceIds": ["kaucja", "rop", "bdo", "dok", "srodowisko"]
		},
		{
			"id": "log",
			"num": "07",
			"slug": "logistyka-zwrotna",
			"title": "Logistyka zwrotna",
			"summary": "Fizyczna warstwa obiegu: odbiory ADR, dzierżawa pojemników Li-ion, sieci punktów zbiórki, zwrotomaty i outsourcing operacji.",
			"serviceIds": ["adr", "pojemniki", "siec", "zwrotna", "zwrotomat", "bpo"]
		},
		{
			"id": "esg",
			"num": "08",
			"slug": "doradztwo-esg-i-raportowanie",
			"title": "Doradztwo ESG i raportowanie",
			"summary": "Warstwa strategiczna: analiza i strategia ESG, raport wg CSRD/ESRS, ślad węglowy, szkolenia, programy dla miast oraz edukacja i obsługa klienta.",
			"serviceIds": ["analiza", "raport", "slad", "szkolenia", "city", "edu", "bok"]
		}
	],
	"industries": [
		{
			"name": "Producenci elektroniki i AGD",
			"desc": "ROP, odzysk, zwroty konsumenckie i raportowanie w jednym łańcuchu.",
			"tag": "ZSEE · ROP · REUSE"
		},
		{
			"name": "Motoryzacja i e-mobilność",
			"desc": "Baterie trakcyjne, pakiety EV, transport ADR i drugie życie ogniw.",
			"tag": "Baterie · ADR"
		},
		{
			"name": "Retail i sieci handlowe",
			"desc": "Zwroty, stoki, punkty zbiórki i obsługa systemu kaucyjnego.",
			"tag": "Kaucja · REUSE"
		},
		{
			"name": "Producenci napojów",
			"desc": "Pełna obsługa wprowadzającego w systemie kaucyjnym.",
			"tag": "System kaucyjny"
		},
		{
			"name": "Moda i tekstylia",
			"desc": "Zbiórka, sortowanie, frakcje handlowe i obowiązki ROP dla tekstyliów.",
			"tag": "Tekstylia · ROP"
		},
		{
			"name": "Samorządy i miasta",
			"desc": "Systemy zbiórki, zwrotomaty, edukacja i wskaźniki GOZ.",
			"tag": "Smart City · ESG"
		},
		{
			"name": "Przemysł i logistyka",
			"desc": "Odpady poprodukcyjne, baterie trakcyjne, ewidencja i zezwolenia.",
			"tag": "BDO · ADR"
		},
		{
			"name": "Energetyka i OZE",
			"desc": "Panele PV, falowniki, magazyny energii i obowiązki środowiskowe.",
			"tag": "OZE · Recykling"
		}
	],
	"cases": [
		{
			"slug": "system-zbiorki-baterii-40-lokalizacji",
			"tag": "Baterie Li-ion",
			"title": "System bezpiecznej zbiórki baterii w sieci 40 lokalizacji",
			"challenge": "Producent elektronarzędzi magazynował zużyte pakiety Li-ion w 40 punktach serwisowych bez jednolitych procedur — z realnym ryzykiem pożarowym i bez ewidencji.",
			"solution": "Audyt, projekt miejsc magazynowania, pojemniki w dzierżawie i cykliczne odbiory ADR skoordynowane w jednym harmonogramie.",
			"outcome": "Po 12 miesiącach: zero zdarzeń pożarowych, pełna ewidencja masy i jeden opiekun dla wszystkich lokalizacji.",
			"stat": "0",
			"statLabel": "zdarzeń pożarowych po wdrożeniu",
			"photo": "p8",
			"serviceIds": ["liion", "adr", "pojemniki"]
		},
		{
			"slug": "tekstylia-dla-zwiazku-gmin",
			"tag": "Tekstylia",
			"title": "Obsługa strumienia tekstyliów dla związku gmin",
			"challenge": "Dwanaście gmin musiało uruchomić selektywną zbiórkę tekstyliów bez własnej sortowni i bez modelu rozliczeń.",
			"solution": "Model przyjęcia z PSZOK, sortowanie na frakcje handlowe i comiesięczne raportowanie mas dla każdej gminy osobno.",
			"outcome": "Strumień 1 400 ton rocznie zagospodarowany z podziałem na frakcje handlowe, czyściwo i odpad.",
			"stat": "1 400 t",
			"statLabel": "strumienia rocznie",
			"photo": "p6",
			"serviceIds": ["sort", "pszok", "hurt"]
		},
		{
			"slug": "drugie-zycie-zwrotow-sieci-handlowej",
			"tag": "REUSE",
			"title": "Drugie życie zwrotów konsumenckich sieci handlowej",
			"challenge": "Palety zwrotów konsumenckich AGD trafiały do utylizacji, mimo że większość sprzętu była sprawna.",
			"solution": "Grading, refurbishment i sprzedaż wielokanałowa — z certyfikatem sprawności dla każdego urządzenia.",
			"outcome": "68% towaru wróciło do obrotu w kanałach D2C i B2B zamiast do recyklingu.",
			"stat": "68%",
			"statLabel": "towaru wróciło do obrotu",
			"photo": "p7",
			"serviceIds": ["refurb", "grading", "omni"]
		},
		{
			"slug": "onboarding-producenta-napojow-do-systemu-kaucyjnego",
			"tag": "System kaucyjny",
			"title": "Onboarding producenta napojów do systemu kaucyjnego",
			"challenge": "Producent z 340 SKU musiał wejść w system kaucyjny bez gotowej struktury danych i modelu rozliczeń.",
			"solution": "Analiza SKU, model rozliczeń, integracja danych z operatorem i uruchomienie raportowania okresowego.",
			"outcome": "Wszystkie 340 SKU objęte systemem, raportowanie działa w cyklu miesięcznym.",
			"stat": "340",
			"statLabel": "SKU objętych systemem",
			"photo": "p5",
			"serviceIds": ["kaucja", "rop"]
		},
		{
			"slug": "pierwszy-raport-csrd-dla-grupy-produkcyjnej",
			"tag": "ESG",
			"title": "Pierwszy raport CSRD dla grupy produkcyjnej",
			"challenge": "Grupa produkcyjna stanęła przed pierwszym obowiązkowym raportem wg ESRS bez zebranych danych E, S i G.",
			"solution": "Analiza podwójnej istotności, policzenie śladu węglowego w trzech zakresach i opracowanie raportu pod przyszłą atestację.",
			"outcome": "Raport złożony w terminie, pełny zakres emisji Scope 1–3 udokumentowany.",
			"stat": "Scope 1–3",
			"statLabel": "pełen zakres emisji",
			"photo": "rozmowy",
			"serviceIds": ["analiza", "raport", "slad"]
		},
		{
			"slug": "ogolnopolska-siec-zbiorki-elektroodpadow",
			"tag": "ZSEE",
			"title": "Ogólnopolska sieć zbiórki elektroodpadów",
			"challenge": "Rozproszona zbiórka elektroodpadów od mieszkańców bez jednego kanału zgłoszeń i bez danych o efektach.",
			"solution": "Czerwone pojemniki, odbiory wielkogabarytowe z domu i kampania edukacyjna dla mieszkańców.",
			"outcome": "Zgłoszenia przyjmowane przez formularz w trybie 24/7, efekty raportowane wskaźnikowo.",
			"stat": "24/7",
			"statLabel": "zgłoszenia przez formularz",
			"photo": "stoisko-tlum",
			"serviceIds": ["siec", "zwrotna", "edu"]
		}
	],
	"insights": [
		{
			"slug": "rozporzadzenie-bateryjne-ue-2023-1542",
			"tag": "Regulacje",
			"title": "Rozporządzenie bateryjne UE 2023/1542 — co zmienia dla producenta",
			"excerpt": "Nowe obowiązki w zakresie zbiórki, paszportu baterii i poziomów odzysku, w praktycznym ujęciu.",
			"readingMinutes": 7
		},
		{
			"slug": "kaucja-w-praktyce-dane-sku-rozliczenia",
			"tag": "System kaucyjny",
			"title": "Kaucja w praktyce: dane, SKU i rozliczenia",
			"excerpt": "Jak przygotować listę produktów i uniknąć najczęstszych błędów wdrożeniowych.",
			"readingMinutes": 6
		},
		{
			"slug": "selektywna-zbiorka-tekstyliow-model-dla-gmin",
			"tag": "Tekstylia",
			"title": "Selektywna zbiórka tekstyliów — model dla gmin",
			"excerpt": "Od PSZOK po sortownię: kto odpowiada za jaki etap i jak liczyć efekt.",
			"readingMinutes": 8
		},
		{
			"slug": "podwojna-istotnosc-krok-po-kroku",
			"tag": "ESG",
			"title": "Podwójna istotność krok po kroku",
			"excerpt": "Jak przeprowadzić analizę, która przejdzie atestację i nie zajmie roku.",
			"readingMinutes": 9
		},
		{
			"slug": "baterie-li-ion-w-magazynie-ryzyko-pozarowe",
			"tag": "Bezpieczeństwo",
			"title": "Baterie Li-ion w magazynie — jak ograniczyć ryzyko pożarowe",
			"excerpt": "Pojemniki, procedury, szkolenia i tryb odbioru interwencyjnego.",
			"readingMinutes": 5
		},
		{
			"slug": "reuse-przed-recyklingiem-kiedy-sie-oplaca",
			"tag": "GOZ",
			"title": "REUSE przed recyklingiem — kiedy to się opłaca",
			"excerpt": "Rachunek ekonomiczny drugiego obiegu dla zwrotów i nadwyżek magazynowych.",
			"readingMinutes": 6
		}
	],
	"pillars": [
		{
			"title": "Recykling i przetwarzanie",
			"desc": "Zakłady ZSEE, baterii, chłodnictwa i elektroniki."
		},
		{ "title": "Ponowne użycie", "desc": "Refurbishment, grading i sprzedaż wielokanałowa." },
		{ "title": "Tekstylia", "desc": "Sortownia, frakcje handlowe i eksport." },
		{ "title": "Zbiórka i logistyka", "desc": "Flota ADR, pojemniki i sieci punktów." },
		{
			"title": "System kaucyjny i ROP",
			"desc": "Operacje, dane i obsługa wprowadzających."
		},
		{ "title": "ESG i edukacja", "desc": "Raportowanie, doradztwo i programy społeczne." }
	],
	"magnets": [
		{
			"slug": "system-kaucyjny-po-pierwszym-roku",
			"kind": "Raport",
			"tag": "System kaucyjny",
			"title": "System kaucyjny po pierwszym roku — dane i wnioski",
			"desc": "Realne poziomy zwrotów, koszty operacyjne i najczęstsze błędy wprowadzających. 28 stron, dane z rynku PL.",
			"meta": "PDF · 28 stron",
			"cta": "Pobierz raport",
			"doneTitle": "Materiał w drodze",
			"doneDesc": "Link do pobrania raportu wysłaliśmy na podany adres."
		},
		{
			"slug": "rop-dla-tekstyliow-webinar",
			"kind": "Webinar",
			"tag": "ROP tekstylia",
			"title": "ROP dla tekstyliów: jak przygotować się przed terminem",
			"desc": "60 minut z zespołem sortowni i doradcami — obowiązki, koszty, harmonogram wdrożenia w firmie.",
			"meta": "Nagranie · 60 min",
			"cta": "Obejrzyj webinar",
			"doneTitle": "Dostęp do nagrania wysłany",
			"doneDesc": "Link do nagrania webinaru wysłaliśmy na podany adres."
		},
		{
			"slug": "zero-zdarzen-pozarowych-case-study",
			"kind": "Case study",
			"tag": "Baterie Li-ion",
			"title": "Zero zdarzeń pożarowych w sieci 40 lokalizacji",
			"desc": "Jak producent elektronarzędzi ułożył zbiórkę baterii — audyt, pojemniki, odbiory ADR i wyniki po 12 miesiącach.",
			"meta": "PDF · 9 stron",
			"cta": "Pobierz case study",
			"doneTitle": "Materiał w drodze",
			"doneDesc": "Link do pobrania case study wysłaliśmy na podany adres."
		}
	]
}
